import { EditorModes, PcbNodeTypes, ReviewType } from "@buildwithflux/models";
import { filterTruthy } from "../../helpers";
import { getProblemTypeKeyFromReviewType } from "../types";
export class InvalidFillsValidator {
    reviewType = ReviewType.DesignRuleCheckOverlappingFills;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    async checkForProblems({ pcbLayoutNodes }) {
        const netsWithFills = Object.values(pcbLayoutNodes).filter((node) => {
            if (node.type === PcbNodeTypes.net) {
                return node.bakedRules.connectedLayers && node.bakedRules.connectedLayers.length > 0;
            }
            return false;
        });
        const possibleFillLayers = filterTruthy(Array.from(new Set(netsWithFills.flatMap((net) => net.bakedRules.connectedLayers))));
        const fillsPerLayer = possibleFillLayers.map((layer) => ({
            layer,
            fills: netsWithFills.filter((net) => net.bakedRules.connectedLayers?.includes(layer)),
        }));
        // If there is an "All" layer, we manualy add it to every fill
        const allRecord = fillsPerLayer.find((fpl) => fpl.layer === "All");
        if (allRecord) {
            // eslint-disable-next-line @buildwithflux/no-array-foreach
            fillsPerLayer.forEach((fpl) => {
                // eslint-disable-next-line @buildwithflux/no-array-foreach
                if (fpl !== allRecord)
                    allRecord.fills.forEach((f) => fpl.fills.push(f));
            });
        }
        const layersWithProblems = fillsPerLayer.filter((fpl) => fpl.fills.length > 1);
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems: layersWithProblems.map((el) => ({
                problemTypeKey: this.problemTypeKey,
                key: `${this.problemTypeKey}_${el.layer}`,
                label: el.layer,
                affectedItems: el.fills.map((f) => ({ type: "pcbLayoutNode", uid: f.uid })),
                affectedViews: [EditorModes.pcb],
            })),
        };
    }
}
//# sourceMappingURL=InvalidFillsValidator.js.map